import "./payment-fraud-prevention.page.scss";
import "../../html/header/header";
import "../../html/footer/footer";
import { initAccordions } from "../../js/accordion";

window.addEventListener("load", (e) => {
    initAccordions();
});
